module.exports = __webpack_public_path__ + "static/img/UploadSimple.b83cf315.svg";